import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { RoleGuard } from './guards/role.guard';
import { PermissionType } from './models/permission-type-enum';
import { ActiveAccountGuard } from './guards/active-account.guard';

const title = 'Portal Pracownika';
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/pages/home/home.component'),
    title: `${title} | Start`,
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'vacation',
    loadComponent: () => import('./components/pages/vacation/vacation.component'),
    title: `${title} | Urlopy`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'absence',
    loadComponent: () => import('./components/pages/absence/absence.component'),
    title: `${title} | Absencja`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'rcp',
    loadComponent: () => import('./components/pages/rcp/rcp.component'),
    title: `${title} | Kalendarz Pracy`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'loan',
    loadComponent: () => import('./components/pages/loan/loan.component'),
    title: `${title} | Pożyczki`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard],
  },
  {
    path: 'equipment',
    loadComponent: () => import('./components/pages/equipment/equipment.component'),
    title: `${title} | Wyposażenie`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard],
  },
  {
    path: 'idea',
    loadComponent: () => import('./components/pages/idea/idea.component'),
    title: `${title} | Idea`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard],
  },
  {
    path: 'personal-info',
    loadComponent: () => import('./components/pages/my-info/my-info.component'),
    title: `${title} | Informacje`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard],
  },
  {
    path: 'add-nomination',
    loadComponent: () => import('./components/pages/nomination/add-nomination/add-nomination.component'),
    title: `${title} | Nominuj`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'nominations-inbox',
    loadComponent: () => import('./components/pages/nomination/my-nomination/my-nomination.component'),
    title: `${title} | Moje nominacje`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'more/:file',
    loadComponent: () => import('./components/pages/info-carousel/more/more.component'),
    title: `${title} | Więcej`,
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'salary',
    loadComponent: () => import('./components/pages/salary/salary.component'),
    title: `${title} | Wynagrodzenie`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'survey',
    loadComponent: () => import('./components/pages/survey/survey.component'),
    title: `${title} | Ankieta`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard],
  },  
  {
    path: 'taxes',
    loadComponent: () => import('./components/pages/taxes/taxes.component'),
    title: `${title} | Podatki`,
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'calc',
    loadComponent: () => import('./components/pages/raise-calc/raise-calc.component'),
    title: `${title} | Kalkulator`,
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'ta',
    loadComponent: () => import('./components/pages/future-preview/ta/ta.component'),
    title: `${title} | RCP`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'write-to-supervisor',
    loadComponent: () => import('./components/pages/contact/contact.component'),
    title: `${title} | Kontakt`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard]
  },
  {
    path: 'assessment',
    loadComponent: () => import('./components/pages/assessment/assessment.component'),
    title: `${title} | Oceny`,
    canActivate: [OktaAuthGuard, ActiveAccountGuard],
  },
  {
    path: 'help',
    loadComponent: () => import('./app-core/ui/sidenav/help/help.component'),
    title: `${title} | Pomoc`,
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'help/:item',
    loadComponent: () => import('./app-core/ui/sidenav/help/help.component'),
    title: `${title} | Pomoc`,
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'settings',
//    loadChildren: () => import('./components/pages/settings/routes').then(m => m.settingsRoutes),
    loadChildren: () => import('./components/pages/settings/routes'),
    title: `${title} | Ustawienia`,
    canActivate: [OktaAuthGuard, RoleGuard],
    data: {
      expectedRole: [PermissionType.Admin]
    },
  },
  { path: 'login/callback', component: OktaCallbackComponent },
];

